module.exports = __webpack_public_path__ + "static/media/Icono usuarios.cc9e331e.svg";